var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-sm text-grey-300"},[_c('i',{staticClass:"icon uil uil-exclamation-triangle mr-1"}),_vm._v(" "+_vm._s(_vm.$t('p-cart-stock', { stock: _vm.stock }))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }